import {generateInitialState} from "./generateInitialState";
import {authInitialState} from "../features/initialStates";

export const getAuthToken = async () => {
  if (navigator.userAgent.indexOf("median") > -1 || window.median !== undefined) {
    return window.median?.storage?.app
      .get({
        key: "token",
      })
      .then(async result => {
        // Use Median token if exist
        if (result.data) {
          localStorage.setItem("token", result.data);
          return result.data;
        }

        // Use Global state token if exist
        const authState = await generateInitialState("auth", authInitialState);
        if (authState?.token != "") {
          localStorage.setItem("token", authState.token);
          return authState.token;
        }

        // Use LocalStorage token
        return localStorage.getItem("token");
      });
  }

  // const authState = await generateInitialState("auth", authInitialState);
  // if (authState?.token != "") {
  //   localStorage.setItem("token", authState.token);
  //   return authState.token;
  // }

  return localStorage.getItem("token");
};
